import { createSlice } from "@reduxjs/toolkit";
import { getToken, setToken as _setToken, removeToken } from "../../utils";
import { loginAPI } from "../../apis/user";
import {
  setUserInfo as _setUserInfo,
  getUserInfo,
  removeUserInfo,
} from "../../utils/localStorage/userInfo";
import { getManagerDetailAPI } from "../../apis/role";
import { fetchArea } from "./areaStore";


const userStore = createSlice({
  name: "user",
  // 数据状态
  initialState: {
    tokenInfo: getToken() || "", //取得到token就从本地取，取不到就置空
    islogined: getToken()?true:false,
    userInfo: getUserInfo() || {},
    managerDetail:{}
    // managerDetail: getToken()?
    //    (await getManagerDetailAPI(getUserInfo().managerId)).data.data
    //   : {},
  },
  // 同步修改方法
  reducers: {
    setToken(state, action) {
      state.tokenInfo = action.payload;
      _setToken(action.payload); //token持久化
    },
    setUserInfo(state, action) {
      // 获取用户信息
      state.userInfo = action.payload;
      _setUserInfo(action.payload); //存储到本地
    },
    clearUserInfo(state) {
      //清除个人信息
      state.tokenInfo = "";
      state.userInfo = {};
      state.managerDetail={}
      removeToken(); // 清除本地token
      removeUserInfo();
    },
    setManagerDeatil(state, action) {
      state.managerDetail = action.payload;
    },
    setLoginState(state, action) {
      state.islogined = action.payload;
    },
  },
});
// 解构actionCreater方法
const {
  setToken,
  setUserInfo,
  clearUserInfo,
  setManagerDeatil,
  setLoginState,
} = userStore.actions;
//异步方法
//向后端获取token
const fetchLogin = (loginForm) => {
  return async (dispatch) => {
    const res = await loginAPI(loginForm);
    
    if(res){
      console.log("拿到token", res.data.data.tokenInfo.admin_access_token);
      // 修改登录信息
      dispatch(setToken(res.data.data.tokenInfo));
      dispatch(setLoginState(true));
      dispatch(setUserInfo(res.data.data.managerInfo));
      // 获取区域列表
      dispatch(fetchArea());
    }

  };
};

// 获取用户详细信息
const fetchManagerDetail = (managerId) => {
  return async (dispatch) => {
    // const res = await getManagerDetailAPI(managerId);
    getManagerDetailAPI(managerId).then((res)=>{
      dispatch(setManagerDeatil(res.data.data));
    }).catch((err)=>{
      console.log(err.message)
    })
  };
};

const userReducer = userStore.reducer;
export { fetchLogin, fetchManagerDetail, clearUserInfo, setLoginState }; //按需导出
export default userReducer; //默认导出
